import { css } from "@emotion/react";

export const iframeStyles = css`
  height: 100%;
  width: 100%;
`;
